import classNames from 'classnames';
import PropTypes from 'prop-types';

const CheckListIcon = ({ className }) => {
  const iconClassName = classNames('check-list-icon', className);
  return (
    <svg className={iconClassName} width='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M8.33325 5.00008C8.33325 4.53984 8.70635 4.16675 9.16659 4.16675L17.4999 4.16675C17.9602 4.16675 18.3333 4.53984 18.3333 5.00008C18.3333 5.46032 17.9602 5.83342 17.4999 5.83342L9.16659 5.83341C8.70635 5.83341 8.33325 5.46032 8.33325 5.00008Z'
        fill='currentColor'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M8.33325 10.0001C8.33325 9.53984 8.70635 9.16675 9.16659 9.16675L17.4999 9.16675C17.9602 9.16675 18.3333 9.53984 18.3333 10.0001C18.3333 10.4603 17.9602 10.8334 17.4999 10.8334L9.16659 10.8334C8.70635 10.8334 8.33325 10.4603 8.33325 10.0001Z'
        fill='currentColor'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M8.33325 15.0001C8.33325 14.5398 8.70635 14.1667 9.16659 14.1667L17.4999 14.1667C17.9602 14.1667 18.3333 14.5398 18.3333 15.0001C18.3333 15.4603 17.9602 15.8334 17.4999 15.8334L9.16659 15.8334C8.70635 15.8334 8.33325 15.4603 8.33325 15.0001Z'
        fill='currentColor'
      />
      <path
        d='M7.37327 2.89178C7.61719 3.28206 7.49855 3.79619 7.10827 4.04011C6.46394 4.44281 5.82029 5.32225 5.3068 6.22085C5.06102 6.65097 4.86347 7.0521 4.72745 7.34578C4.67553 7.45641 4.57 7.70098 4.52373 7.80944C4.40284 8.11141 4.11714 8.31584 3.79228 8.33237C3.46733 8.3489 3.16248 8.1748 3.01161 7.88653C2.86724 7.61069 2.63373 7.3524 2.40999 7.15024C2.32255 7.06806 2.12996 6.92168 2.0446 6.85876C1.65927 6.60738 1.55056 6.09125 1.80181 5.70578C2.05312 5.32022 2.56941 5.21139 2.95498 5.4627C3.06847 5.53918 3.34839 5.7424 3.56013 5.94345C3.6507 5.76943 3.75083 5.58452 3.85973 5.39395C4.38791 4.46964 5.20259 3.26574 6.22493 2.62678C6.61522 2.38285 7.12934 2.5015 7.37327 2.89178Z'
        fill='currentColor'
      />
      <path
        d='M7.37327 12.0583C7.61719 12.4486 7.49855 12.9627 7.10827 13.2066C6.46394 13.6093 5.82029 14.4888 5.3068 15.3874C5.06102 15.8175 4.86347 16.2186 4.72745 16.5123C4.67553 16.6229 4.57 16.8675 4.52373 16.9759C4.40284 17.2779 4.11714 17.4823 3.79228 17.4989C3.46733 17.5154 3.16248 17.3413 3.01161 17.053C2.86724 16.7772 2.63373 16.5189 2.40999 16.3167C2.32255 16.2346 2.12996 16.0882 2.0446 16.0253C1.65927 15.7739 1.55056 15.2578 1.80181 14.8723C2.05312 14.4867 2.56941 14.3779 2.95498 14.6292C3.06847 14.7057 3.34839 14.9089 3.56013 15.11C3.6507 14.9359 3.75083 14.751 3.85973 14.5605C4.38791 13.6361 5.20259 12.4322 6.22493 11.7933C6.61522 11.5494 7.12934 11.668 7.37327 12.0583Z'
        fill='currentColor'
      />
    </svg>
  );
};

CheckListIcon.propTypes = {
  className: PropTypes.string,
};

export default CheckListIcon;
